import { useState } from "react";

const bullets = [
  {
    icon: "ri-sun-line",
    title: "日间清新",
    desc: "低饱和度暖色背景，白天看字画清晰，久看不累。",
  },
  {
    icon: "ri-moon-clear-line",
    title: "夜间护眼",
    desc: "一键切换深色暖调，自动降低亮度与眩光，深夜追更更安心。",
  },
  {
    icon: "ri-eye-line",
    title: "自适应亮度",
    desc: "根据环境光柔和过渡，翻页不闪屏，观感始终舒适。",
  },
];

export default function Showcase() {
  const [night, setNight] = useState(false);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="text-sm font-semibold tracking-wide text-primary-500">阅读体验</span>
          <h2 className="mt-2 text-2xl leading-snug md:text-4xl">
            白天清新，
            <br className="hidden md:block" />
            夜间不刺眼
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            扑飞漫画网的夜间模式经过精心调校，不只是单纯"变黑"，而是调整对比度与色温，让深色背景下的画面依然清晰立体，翻页顺滑不闪屏。
          </p>

          <ul className="mt-8 space-y-5">
            {bullets.map((b) => (
              <li key={b.title} className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-xl text-secondary-700">
                  <i className={b.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-base text-foreground-950">{b.title}</h3>
                  <p className="mt-1 text-sm text-foreground-700">{b.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="order-1 flex justify-center lg:order-2">
          <div
            className={`w-full max-w-sm rounded-xl border p-6 transition-colors duration-500 ${
              night
                ? "border-background-300 bg-background-900 text-background-50"
                : "border-background-200 bg-background-100 text-foreground-950"
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold">当前演示</span>
              <button
                type="button"
                onClick={() => setNight((v) => !v)}
                className={`flex h-9 w-9 items-center justify-center rounded-md text-lg transition-colors ${
                  night ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-800"
                }`}
              >
                <i className={night ? "ri-moon-clear-line" : "ri-sun-line"} />
              </button>
            </div>

            <div className={`mt-5 rounded-lg p-4 ${night ? "bg-background-800/70" : "bg-background-50"}`}>
              <span className="text-xs text-primary-500">山月江湖 · 第127话</span>
              <h3 className="mt-2 font-heading text-lg">
                {night ? "夜色渐深，剑气纵横" : "山雨欲来，风满楼"}
              </h3>
              <p className={`mt-3 text-sm leading-relaxed ${night ? "text-background-200" : "text-foreground-700"}`}>
                {night
                  ? "月光洒在青石阶上，少年握紧手中长剑，夜风卷起衣角。远处的灯笼明灭，一场激战一触即发。"
                  : "阳光穿过竹林，洒下斑驳光影。少年在溪边擦拭剑刃，眼神坚定，远处传来隐约的号角声。"}
              </p>
            </div>

            <div className={`mt-4 rounded-lg p-3 text-sm ${night ? "bg-background-800/70" : "bg-background-50"}`}>
              <div className="flex items-center justify-between text-foreground-600">
                <span className={night ? "text-background-200" : "text-foreground-600"}>下一话</span>
                <span className={night ? "text-background-200" : "text-foreground-600"}>126 / 158</span>
              </div>
              <div className={`mt-2 h-1.5 w-full overflow-hidden rounded-full ${night ? "bg-background-700" : "bg-background-200"}`}>
                <div className="h-full w-2/3 rounded-full bg-primary-500" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}